import { PREFIX } from './base';

export const DEFAULT_HIERARCHY_DEPTH = `${PREFIX}_HIERARCHY_DEPTH`;
export const DEFAULT_HIERARCHY_ROOT = `${PREFIX}_HIERARCHY_ROOT`;
export const DEFAULT_HIERARCHY_ROOT_INDEX = `${PREFIX}_HIERARCHY_ROOT_INDEX`;
